class HeaderMenu extends HTMLElement {
    constructor() {
        super();
        this.details = this.querySelectorAll('details');
        this.addEventListeners();
    }

    addEventListeners() {
        this.details.forEach(detail => {
            detail.addEventListener('toggle', this.onToggle.bind(this));
        });

        document.addEventListener('click', this.onBodyClick.bind(this));
    }

    onToggle(event) {
        const targetDetail = event.target;
        if (targetDetail.open) {
            this.closeOthers(targetDetail);
        }
    }

    closeOthers(currentDetail) {
        this.details.forEach(detail => {
            if (detail !== currentDetail && detail.open) {
                detail.removeAttribute('open');
            }
        });
    }

    onBodyClick(event) {
        const isInsideMenu = this.contains(event.target);
        if (!isInsideMenu) {
            this.closeAll();
        }
    }

    closeAll() {
        this.details.forEach(detail => {
            if (detail.open) {
                detail.removeAttribute('open');
            }
        });
    }
}

customElements.define('header-menu', HeaderMenu);
